<template>
  <div>
    <Info />
    <CheckTable :checkList=startCheck @changedCheckbox=changedCheckbox></CheckTable>
    <ButtonBar @back="back" @next="next"></ButtonBar>
  </div>
</template>

<script>
  import CheckTable from '@/components/parts/CheckTable';

  export default {
    name: 'StartCheck',
    components: {
      CheckTable,
    },
    created() {
      this.$parent.title = '';
      this.$parent.imageName = 'startCheck';
      this.$parent.hasMaintenancne = true;
      this.$parent.showMaintenanceInformation = true;
    },
    data() {
      return {
        startCheck: this.$store.getters.startCheck,
        backPageName: this.$store.getters.routes.startCheck.back,
        nextPageName: this.$store.getters.routes.startCheck.next,
      };
    },
    methods: {
      back() {
        this.$router.push({ name: this.backPageName });
      },
      next() {
        const result = Object.values(this.startCheck.answers).some(value => !value);
        if (result) {
          alert('未選択のチェック項目があります。');
        } else {
          this.$router.push({ name: this.nextPageName });
        }
        return true;
      },
      changedCheckbox(key, answer) {
        const type = 'startCheck';
        this.$store.dispatch('setCheckAnswer', { type, key, answer });
      },
    },
  };
</script>

<style lang="scss" scoped>
dl {
  dt, dd {
    padding: 0.5rem 3rem;

    .md-checkbox.md-theme-default.md-checked .md-ripple {
      color: #52ff52;
      color: var(--md-theme-default-accent, #52ff52);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StartCheck.vue?3aaa52ef